// import { request } from '@/utils/request';
import { request } from '@/utils/request';
import React from 'react';

export const statusTrans = {
  0: '已停用',
  1: '已开通',
  2: '审核中',
  '-1': '审核不通过',
  '-2': '删除',
  '-3': '失效',
  '-4': '未开通',
};


const urls = {
  info: '/api/templateMockApi/privilege-allocation/info', // 信息
  list: '/api/workbench/positionManager/tenant', // 列表
  delete: '/api/workbench/posts/deletes', // 删除
  detail: '/api/positionManager/getDetail', // 详情
  update: '/api/workbench/positionManager/tenant/update', // 更新区划岗位配置
  pagingPositions: '/api/workbench/posts/allocation/pagingAvailable', // 所有岗位列表接口 运营区划管理员查询使用
  deletePositionManager: '/api/workbench/positionManager/tenant', // 删除分配岗位配置
  allocation: '/api/workbench/positionManager/tenant/allocation', // 分配岗位创建
  userCategoryList: '/api/userCategories/getRoleSupportAndHasTenantCategory', // 获取岗位绑定的用户类别列表
};

export const treeTrans = (list) => {
  return list?.map((item) => {
    item.key = item.code;
    item.title = (
      <span style={ { display: 'inline-block', width: '100%', position: 'relative' } }>
        {item.name}
      </span>
    );
    return item;
  });
};


export async function reqInfo (params) {
  return request(urls.info, {
    params,
  });
}

export async function reqList (params) {
  const { id, pageNo, pageSize } = params;
  return request(`${urls.list}/${id}`, {
    params: { pageNo, pageSize },
  });
}
export async function positionManagerTenantUpdate ({ ...params }) {
  return request(urls.update, {
    method: 'post',
    data: {
      ...params,
    },
  });
}

export async function positionManagerTenantAllocation ({ ...params }) {
  return request(urls.allocation, {
    method: 'post',
    data: {
      ...params,
    },
  });
}

export async function pagingPositions (params) {
  return request(urls.pagingPositions, {
    params,
  });
}

export async function getUserCategoryList (params) {
  return request(urls.userCategoryList, {
    params,
  });
}

export async function deletePositionManager ({ ...params }) {
  const { id } = params;
  return request(`${urls.deletePositionManager}/${id}`, {
    method: 'delete',
    data: {
      ...params,
    },
  });
}
